import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withGlobalError } from '@/react-tools/react-query';

import { PolicyType } from '../types';

import { queryKeys } from './query-keys';

export interface PolicyMetadata {
  minimumAgentVersions: Record<PolicyType, string>;
}

/** Get policy metadata (minimum agent versions for checking compatibility) from the API */
export function usePolicyMetadata() {
  return useQuery({
    queryKey: queryKeys.metadata(),
    queryFn: getPolicyMetadata,
    staleTime: 1000 * 60 * 60, // 1 hour - cache to reduce API calls but refresh when new policy types are added
    ...withGlobalError('Unable to load policy metadata'),
  });
}

async function getPolicyMetadata(): Promise<PolicyMetadata> {
  try {
    const { data } = await axios.get<PolicyMetadata>('/policies/metadata');
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve policy metadata');
  }
}
